import React from 'react';
import {
  Box,
  Text,
  Button,
  VStack,
  HStack,
  Badge,
  Checkbox,
} from '@chakra-ui/react';
import { primaryButtonProps, secondaryButtonProps } from '../../theme/adminUi';

const formatClock = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleTimeString('es-UY', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

/**
 * Inicio / fin de prueba dinámica (requerida antes de finalizar el servicio,
 * salvo que se marque "No aplica prueba dinámica").
 */
const ServiceDynamicTestPanel = ({
  start,
  end,
  notApplicable = false,
  canControl = false,
  onStart,
  onEnd,
  onNotApplicableChange,
  isSaving = false,
}) => {
  const hasStart = Boolean(start);
  const hasEnd = Boolean(end);
  const statusLabel = notApplicable
    ? 'No aplica'
    : hasEnd
      ? 'Finalizada'
      : hasStart
        ? 'En curso'
        : 'Pendiente';
  const statusColor = notApplicable
    ? 'purple'
    : hasEnd
      ? 'green'
      : hasStart
        ? 'orange'
        : 'gray';

  return (
    <Box
      w="100%"
      borderWidth="1px"
      borderRadius="md"
      p={3}
      bg="gray.50"
      borderColor="gray.200"
    >
      <HStack justify="space-between" mb={2}>
        <Text fontSize="xs" fontWeight="bold" color="gray.600" letterSpacing="wide">
          PRUEBA DINÁMICA
        </Text>
        <Badge colorScheme={statusColor} fontSize="xs" variant="subtle">
          {statusLabel}
        </Badge>
      </HStack>

      {!notApplicable && (
        <VStack align="stretch" spacing={1} mb={3}>
          <HStack justify="space-between">
            <Text fontSize="sm" color="gray.600">
              Inicio
            </Text>
            <Text fontSize="sm" fontWeight="semibold" fontFamily="mono">
              {formatClock(start)}
            </Text>
          </HStack>
          <HStack justify="space-between">
            <Text fontSize="sm" color="gray.600">
              Fin
            </Text>
            <Text fontSize="sm" fontWeight="semibold" fontFamily="mono">
              {formatClock(end)}
            </Text>
          </HStack>
        </VStack>
      )}

      {canControl && (
        <VStack align="stretch" spacing={2}>
          {!notApplicable && (
            <HStack spacing={2}>
              <Button
                {...primaryButtonProps}
                flex={1}
                size="sm"
                onClick={onStart}
                isDisabled={hasStart || isSaving}
                isLoading={isSaving && !hasStart}
              >
                Iniciar prueba
              </Button>
              <Button
                {...secondaryButtonProps}
                flex={1}
                size="sm"
                onClick={onEnd}
                isDisabled={!hasStart || hasEnd || isSaving}
                isLoading={isSaving && hasStart && !hasEnd}
              >
                Finalizar prueba
              </Button>
            </HStack>
          )}

          <Checkbox
            size="sm"
            colorScheme="purple"
            isChecked={notApplicable}
            onChange={(e) => onNotApplicableChange?.(e.target.checked)}
            isDisabled={isSaving || (hasStart && !hasEnd)}
          >
            <Text fontSize="sm">No aplica prueba dinámica</Text>
          </Checkbox>
        </VStack>
      )}
    </Box>
  );
};

export default ServiceDynamicTestPanel;
